document.addEventListener("DOMContentLoaded", () => {
  const formContainer = document.querySelector(".fui-form-container");
  if (!formContainer) return;
  // The giant page-number + progress polish is exclusive to the
  // Tevredenheidsenquete page (entry 1872), whose template wraps the form in
  // `.enquete`. Every other form (event inschrijving, contact, offerte, and
  // kalibratie — which has its own wizard helper) must NOT get a page number.
  if (!formContainer.closest(".enquete")) return;

  const progressContainer = formContainer.querySelector(
    ".fui-progress-container"
  );
  const pages = [...formContainer.querySelectorAll(".fui-page")];
  const buttons = document.querySelectorAll(".enquete .fui-btn");
  const progressBar = document.querySelector(".fui-progress-value");

  if (progressBar) {
    progressBar.style.display = "none";
  }

  buttons.forEach((button) => {
    button.classList.add("noStyle");
  });

  function updatePageNumber() {
    // Find the visible page (not hidden)
    const visiblePage = pages.find(
      (page) => !page.hasAttribute("data-fui-page-hidden")
    );

    if (!visiblePage) return;

    const pageIndex = parseInt(visiblePage.dataset.index, 10) || 0;
    const totalPages = pages.length;

    // Find the heading inside the visible page
    const heading = visiblePage.querySelector(".fui-heading");

    if (!heading) return;

    // Check if the page number span already exists, else create it
    let pageNumberSpan = heading.querySelector(".page-number");
    if (!pageNumberSpan) {
      pageNumberSpan = document.createElement("span");
      pageNumberSpan.classList.add("page-number");
      pageNumberSpan.style.fontWeight = "bold";
      pageNumberSpan.style.marginRight = "10px";
      pageNumberSpan.style.fontSize = "62px";
      heading.prepend(pageNumberSpan);
    }

    pageNumberSpan.textContent = `${pageIndex + 1}`;
  }

  function adjustProgressMargin() {
    if (!progressContainer) return;

    const visiblePage = pages.find(
      (page) => !page.hasAttribute("data-fui-page-hidden")
    );
    if (!visiblePage) return;

    const heading = visiblePage.querySelector(".fui-heading");
    if (!heading) return;

    const headingHeight = heading.offsetHeight;

    // Apply negative margin bottom equal to heading height (plus a small padding maybe)
    progressContainer.style.marginBottom = `-${headingHeight + 10 + 10}px`;
    progressContainer.style.opacity = "100%";
  }

  function checkHeadingLinesAndAlign() {
    const visiblePage = pages.find(
      (page) => !page.hasAttribute("data-fui-page-hidden")
    );
    if (!visiblePage) return;

    const heading = visiblePage.querySelector(".fui-heading");
    if (!heading) return;

    // Get computed styles for the heading
    const style = window.getComputedStyle(heading);
    const lineHeight = parseFloat(style.lineHeight);
    const height = heading.offsetHeight;

    // If height > lineHeight, it's multiline
    if (height > lineHeight * 1.1) {
      // Add style to align center
      heading.style.display = "flex";
      heading.style.alignItems = "center";
    } else {
      // Reset to default baseline alignment
      heading.style.display = "flex";
      heading.style.alignItems = "baseline"; // or flex-start if you want
    }
  }

  function update() {
    updatePageNumber();
    setTimeout(() => {
      adjustProgressMargin();
    }, 50);
    checkHeadingLinesAndAlign();
  }

  // Initial update
  update();

  // Listen for page changes: assuming the form fires an event or you can detect changes on .fui-page-hidden attribute
  // Here a MutationObserver example to detect page visibility changes:
  const observer = new MutationObserver(() => {
    update();
  });

  // Recalculate progress margin when the window resizes
  window.addEventListener("resize", adjustProgressMargin);

  pages.forEach((page) => {
    observer.observe(page, {
      attributes: true,
      attributeFilter: ["data-fui-page-hidden"],
    });
  });
});
